// extracted by mini-css-extract-plugin
export default {"sortable-item":"e7S2q"};